import Styles from '../../assets/styles.scss';

import 'highlight.js/styles/github.min.css';

export const MarkdownCode = ({ node, inline, className, children, ...props }) => {
	return (
		<code
			className={[className, Styles.mdCode].join(' ')}
			{...props}
		>
			{children}
		</code>
	);
};
